import { Model } from "@/models/base/model";

export class Tag extends Model {
  constructor(params: any = {}) {
    super(params);
  }

  // タグ一覧取得（ログインユーザに紐づく）
  async getUserTags(): Promise<any> {
    this.url = "/cms/api/users/tags/list";
    return await super.fetch();
  }

  // タグ一覧取得
  async getTags(cond: any): Promise<any> {
    const params = new URLSearchParams();

    if (cond.tagIds?.length > 0) {
      params.append("tagIds", cond.tagIds.join(","));
    }

    const queryString = params.toString() ? "?" + params.toString() : "";
    this.url = `/cms/api/tags/list${queryString}`;
    return await super.fetch();
  }

  // タグ登録更新
  async updateUserTags(tagId: number): Promise<any> {
    this.url = "/cms/api/users/tags/update";
    return await this.save({ tagId }, "POST");
  }
}
